// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_broadcastQuietPropertyV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DuplicatePropertyError",
    "GeocodingError",
    "PropertyNotElgibleForBroadcast",
    "QuietPropertyBroadcasted"
  ]);
}

let variablesConverter = {"broadcastQuietPropertyV5Input":{"showings":{"r":"propertyShowingV5Input"},"price":{"r":"propertyPriceInput"},"mlsListing":{"r":"mlsListingForSaleInput"},"location":{"r":"propertyLocationInput"},"images":{"r":"attachmentV5Input"},"files":{"r":"attachmentV5Input"},"attributes":{"r":"forSalePropertyAttributesInput"}},"propertyShowingV5Input":{"date":{"b":""}},"attachmentV5Input":{},"singleFamilyAttributesInput":{},"propertyLocationInput":{},"mlsListingForSaleInput":{"onMlsAt":{"b":""}},"lotAttributesInput":{},"condoAttributesInput":{},"exactPriceInput":{"price":{"b":""}},"propertyPriceInput":{"priceRange":{"r":"priceRangeInput"},"exactPrice":{"r":"exactPriceInput"}},"multiUnitAttributesInput":{},"forSalePropertyAttributesInput":{"singleFamily":{"r":"singleFamilyAttributesInput"},"multiUnit":{"r":"multiUnitAttributesInput"},"lot":{"r":"lotAttributesInput"},"condo":{"r":"condoAttributesInput"}},"priceRangeInput":{"minPrice":{"b":""},"maxPrice":{"b":""}},"__root":{"input":{"r":"broadcastQuietPropertyV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"broadcastQuietPropertyV5":{"u":"response_broadcastQuietPropertyV5"}}};

let wrapResponseConverterMap = {
  response_broadcastQuietPropertyV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"broadcastQuietPropertyV5":{"u":"response_broadcastQuietPropertyV5"}}};

let responseConverterMap = {
  response_broadcastQuietPropertyV5: unwrap_response_broadcastQuietPropertyV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function lotSizeUnit_decode($$enum) {
  if ($$enum === "ACRE" || $$enum === "SQ_FT") {
    return $$enum;
  }
}

let lotSizeUnit_fromString = lotSizeUnit_decode;

function mlsListingTypeV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "OFF_MLS" || $$enum === "COMING_SOON") {
    return $$enum;
  }
}

let mlsListingTypeV5_fromString = mlsListingTypeV5_decode;

function showingTypeV5_decode($$enum) {
  if ($$enum === "AGENTS_ONLY" || $$enum === "TAN_ONLY" || $$enum === "BUYERS_WELCOME") {
    return $$enum;
  }
}

let showingTypeV5_fromString = showingTypeV5_decode;

let Utils = {
  lotSizeUnit_decode: lotSizeUnit_decode,
  lotSizeUnit_fromString: lotSizeUnit_fromString,
  mlsListingTypeV5_decode: mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: mlsListingTypeV5_fromString,
  showingTypeV5_decode: showingTypeV5_decode,
  showingTypeV5_fromString: showingTypeV5_fromString
};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "DuplicatePropertyError",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "GeocodingError",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "PropertyNotElgibleForBroadcast",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "broadcastQuietPropertyV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "editableProperty",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "QuietPropertyBroadcasted",
            "abstractKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "broadcastQuietPropertyV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "editableProperty",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v9/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "QuietPropertyBroadcasted",
            "abstractKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc12334bc26d09b1bcd19f160c42b766",
    "id": null,
    "metadata": {},
    "name": "PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation",
    "operationKind": "mutation",
    "text": "mutation PropertyWizardFormRelayMutations_BroadcastQuietPropertyV5Mutation(\n  $input: BroadcastQuietPropertyV5Input!\n) {\n  broadcastQuietPropertyV5(input: $input) {\n    __typename\n    ... on DuplicatePropertyError {\n      message\n    }\n    ... on QuietPropertyBroadcasted {\n      client {\n        __typename\n        id\n        nodeId\n      }\n      editableProperty: property {\n        __typename\n        property {\n          __typename\n          nodeId\n        }\n      }\n    }\n    ... on GeocodingError {\n      message\n    }\n    ... on PropertyNotElgibleForBroadcast {\n      message\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_broadcastQuietPropertyV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_broadcastQuietPropertyV5 = unwrap_response_broadcastQuietPropertyV5;
exports.wrap_response_broadcastQuietPropertyV5 = wrap_response_broadcastQuietPropertyV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
